// extracted by mini-css-extract-plugin
export default {"back":"BackButton_back__+Ayx7","icon":"BackButton_icon__D+k9v"};